import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Preloader from './components/Preloader';

const Header = lazy(() => import('./components/common/Header'));
const Footer = lazy(() => import('./components/common/Footer'));

const Home = lazy(() => import('./components/Home'));
const Templates = lazy(() => import('./components/Templates'));
const Faq = lazy(() => import('./components/Faq'));
const Tariff = lazy(() => import('./components/Tariff'));
const Support = lazy(() => import('./components/Support'));

const Site = lazy(() => import('./components/Site'));
const Editor = lazy(() => import('./components/Editor'));

const PersonalChat = lazy(() => import('./components/chunk/PersonalChat'));
const PersonalSites = lazy(() => import('./components/chunk/PersonalSites'));
const PersonalTemplates = lazy(() => import('./components/chunk/PersonalTemplates'));
const PersonalProfile = lazy(() => import('./components/chunk/PersonalProfile'));
const Login = lazy(() => import('./components/chunk/Login'))

const Yachtclub = lazy(() => import('./mobileSite/yachtclub') )
const Panorama = lazy(() => import('./mobileSite/panorama') )


const LoadingFallback = () => (
    <Preloader />
);

const LazyRoute = ({ children }) => (
    <Suspense fallback={<LoadingFallback />}>
        {children}
    </Suspense>
);

// Защищенный маршрут
const ProtectedRoute = ({ isAuthenticated, children }) => {
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }
  
    return <LazyRoute>{children}</LazyRoute>;
};

export default function AppRoutes({ isAuthenticated }) {
    return (
        <Routes>
            {/* Публичный маршрут */}
            <Route 
                path="/" 
                element={
                    <LazyRoute>
                        <Header />
                        <Home />
                        <Footer />
                    </LazyRoute>
                } 
            />
            <Route 
                path="/templates" 
                element={
                    <LazyRoute>
                        <Header />
                        <Templates />
                        <Footer />
                    </LazyRoute>
                } 
            />
            <Route 
                path="/faq" 
                element={
                    <LazyRoute>
                        <Header />
                        <Faq />
                        <Footer />
                    </LazyRoute>
                } 
            />
            <Route 
                path="/tariff" 
                element={
                    <LazyRoute>
                        <Header />
                        <Tariff />
                        <Footer />
                    </LazyRoute>
                } 
            />
            <Route 
                path="/support" 
                element={
                    <LazyRoute>
                        <Header />
                        <Support />
                        <Footer />
                    </LazyRoute>
                } 
            />
            <Route 
                path="/login" 
                element={
                    <LazyRoute>
                        <Header />
                        <Login />
                        <Footer />
                    </LazyRoute>
                } 
            />
            

            {/* Защищенные маршруты */}

            <Route 
                path="/chat" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <PersonalChat /> 
                        <Footer />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/mysites" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <PersonalSites /> 
                        <Footer />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/mytemplates" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <PersonalTemplates /> 
                        <Footer />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/profile" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <PersonalProfile /> 
                        <Footer />
                    </ProtectedRoute>
                } 
            />

            

            <Route 
                path="/mysites/:siteId/*" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Site />
                    </ProtectedRoute>
                } 
            />
            
            <Route 
                path="/mysites/:siteId/edit" 
                element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Editor />
                    </ProtectedRoute>
                } 
            />

            <Route 
                path="*" 
                element={
                    <LazyRoute>
                        <div className="page-404">
                            <div className="header_2">Ошибка 404</div>
                        </div>
                    </LazyRoute>
                } 
            />

            {/* Старые сайты */}
            <Route path="/yachtclub" element={
                <LazyRoute>
                    <Yachtclub />
                </LazyRoute>
            } />

            <Route path="/panorama" element={
                <LazyRoute>
                    <Panorama />
                </LazyRoute>
            } />

            
            
        </Routes>
    )
}